import React, { useCallback } from 'react';
import { MyButton } from '../index';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SuccessfulImage from 'assets/images/Successful.svg';

import './styles.scss';

const SuccessfulScreen = ({
  image,
  title,
  description,
  buttonSecondaryText,
  onClickButtonSecondary,
  onClickButtonPrimary,
  primaryButton,
  className,
  primaryButtonLoading,
}) => {
  const renderText = useCallback((value) => {
    if (!value) return '';
    return value;
  }, []);

  return (
    <div className={classNames('screen-successful view-center', className)}>
      <div className="text-center">
        <img src={image} />
        <h4 className="title">{title}</h4>
        <p className="description">{description}</p>
      </div>
      <div className="text-center">
        {buttonSecondaryText && (
          <MyButton
            onClick={onClickButtonSecondary}
            className="btn-secondary-custom mx-10"
          >
            {renderText(buttonSecondaryText)}
          </MyButton>
        )}
        <MyButton
          onClick={onClickButtonPrimary}
          className="btn-primary-custom my-30"
          loading={primaryButtonLoading}
        >
          {renderText(primaryButton)}
        </MyButton>
      </div>
    </div>
  );
};

SuccessfulScreen.propTypes = {
  image: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonSecondaryText: PropTypes.string,
  primaryButton: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onClickButtonSecondary: PropTypes.func,
  onClickButtonPrimary: PropTypes.func,
  primaryButtonLoading: PropTypes.bool,
};

SuccessfulScreen.defaultProps = {
  image: SuccessfulImage,
  title: 'Success',
  primaryButton: 'Complete',
  onClickButtonSecondary: () => {},
  onClickButtonPrimary: () => {},
  primaryButtonLoading: false,
};

export default SuccessfulScreen;
